import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DetailBooleanComponent, DetailViewModule } from '@ui/shared/ui-detail-view';
import type { PreventionListItemModel } from '../definitions/prevention-list-item.model';

@Component({
    selector: 'ui-prevention-details-content',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DetailViewModule, DetailBooleanComponent],
    templateUrl: './prevention-details-content.component.html',
})
export class PreventionDetailsContentComponent {
    public mapItem = input.required<PreventionListItemModel>();
}
